goog.provide("shadow.js.shim.module$$mui$material$CardActionArea$default");
shadow.js.shim.module$$mui$material$CardActionArea$default = shadow.js.shim.module$$mui$material$CardActionArea.default;
